import { emitClickEvent } from './eventEmitter';

const buildTable = (tableTracking, featureIndex) => {
  const { labels } = tableTracking;

  return {
    ...tableTracking,
    position: parseInt(featureIndex, 10),
    status: 'clicked',
    labels: {
      ...labels,
      promo_Feature: ['true'],
      promo_FilledSlots: labels.promo_FilledSlots
    }
  };
};
const buildRecommendation = (recommendationTracking) => ({
  ...recommendationTracking,
  status: 'clicked'
});

export default (
  tableTracking,
  recommendationTracking,
  featureIndex,
  additionalTableClickTracking,
  additionalRecommendationClickTracking,
  recommendationMeta
) => {
  const event = {
    name: 'click',
    features: [buildTable(tableTracking, featureIndex), buildRecommendation(recommendationTracking)]
  };

  const cleanRecommendationMeta = { ...recommendationMeta };
  delete cleanRecommendationMeta.product_VariationId;
  const additionalClickTrackingLabels = {
    ...additionalTableClickTracking,
    ...additionalRecommendationClickTracking,
    ...cleanRecommendationMeta
  };
  emitClickEvent(event, { promo_Click: tableTracking.name }, additionalClickTrackingLabels);
};
